import { useEffect } from 'react';
import EconomicPlanner from '../../components/EconomicPlanner';
import PageHeader from '../../components/PageHeader';

function PlannerPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "The Calculation Problem - Austrian Process";
  }, []);

  return (
    <div className="page-container">
      <PageHeader
        title="The Calculation Problem"
        description="A central planner with full authority and no prices. Allocate resources across five goods. See what the market already knew."
      />
      <EconomicPlanner />
    </div>
  );
}

export default PlannerPage;
